/* ═════════════════════════════════════
   LIVEMAS VIDA BEAUTY — Main JavaScript
   ═════════════════════════════════════ */

document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

// ── SCROLL REVEAL ──
const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry, i) => {
    if (entry.isIntersecting) {
      setTimeout(() => {
        entry.target.classList.add('visible');
      }, i * 60);
      revealObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));

// ── STAGGER CHILDREN ──
document.querySelectorAll('[data-stagger]').forEach(grid => {
  [...grid.children].forEach((child, i) => {
    child.style.transitionDelay = (i * 0.075) + 's';
  });
});

// ── HEADER SCROLL ──
const header = document.querySelector('.site-header');
if (header) {
  const scrollHandler = () => {
    header.classList.toggle('scrolled', window.scrollY > 20);
  };
  window.addEventListener('scroll', scrollHandler, { passive: true });
}

// ── CART DRAWER ──
const cartDrawer = document.getElementById('CartDrawer');
const overlay = document.getElementById('overlay');
const cartOpenBtns = document.querySelectorAll('[data-cart-open]');
const cartCloseBtns = document.querySelectorAll('[data-cart-close]');

function openCart() {
  if (cartDrawer) {
    cartDrawer.classList.add('open');
    if (overlay) overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    cartDrawer.setAttribute('aria-hidden', 'false');
  }
}

function closeCart() {
  if (cartDrawer) {
    cartDrawer.classList.remove('open');
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';
    cartDrawer.setAttribute('aria-hidden', 'true');
  }
}

cartOpenBtns.forEach(btn => btn.addEventListener('click', openCart));
cartCloseBtns.forEach(btn => btn.addEventListener('click', closeCart));
if (overlay) overlay.addEventListener('click', closeCart);

// Escape key closes cart
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') closeCart();
});

// ── MOBILE MENU ──
const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
const mobileMenu = document.getElementById('MobileMenu');

if (mobileMenuBtn && mobileMenu) {
  mobileMenuBtn.addEventListener('click', () => {
    const isOpen = mobileMenu.classList.toggle('open');
    mobileMenuBtn.setAttribute('aria-expanded', isOpen.toString());
    if (overlay) overlay.classList.toggle('active', isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : '';
  });
}

// ── ACCORDION ──
document.querySelectorAll('.accordion-trigger').forEach(trigger => {
  trigger.addEventListener('click', () => {
    const content = trigger.nextElementSibling;
    const isOpen = trigger.getAttribute('aria-expanded') === 'true';

    // Close all
    document.querySelectorAll('.accordion-trigger').forEach(t => {
      t.setAttribute('aria-expanded', 'false');
      const c = t.nextElementSibling;
      if (c) c.classList.remove('open');
    });

    // Open current if was closed
    if (!isOpen) {
      trigger.setAttribute('aria-expanded', 'true');
      if (content) content.classList.add('open');
    }
  });
});

// ── QUANTITY SELECTORS ──
document.querySelectorAll('.qty-selector').forEach(selector => {
  const input = selector.querySelector('input');
  const decrementBtn = selector.querySelector('[data-qty-minus]');
  const incrementBtn = selector.querySelector('[data-qty-plus]');

  if (decrementBtn && input) {
    decrementBtn.addEventListener('click', () => {
      const val = parseInt(input.value) || 1;
      input.value = Math.max(1, val - 1);
    });
  }

  if (incrementBtn && input) {
    incrementBtn.addEventListener('click', () => {
      const val = parseInt(input.value) || 1;
      input.value = val + 1;
    });
  }
});

// ── PRODUCT GALLERY ──
const galleryMain = document.getElementById('ProductGalleryMain');
const galleryThumbs = document.querySelectorAll('.product-thumb');

galleryThumbs.forEach(thumb => {
  thumb.addEventListener('click', () => {
    const imgSrc = thumb.dataset.src;
    if (galleryMain && imgSrc) {
      galleryMain.querySelector('img').src = imgSrc;
    }
    galleryThumbs.forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
  });
});

// ── ADD TO CART ──
document.querySelectorAll('.atc-btn').forEach(btn => {
  btn.addEventListener('click', async (e) => {
    const variantId = btn.dataset.variantId;
    const qtyInput = btn.closest('[data-product-form]')?.querySelector('.qty-selector input');
    const qty = parseInt(qtyInput?.value) || 1;

    if (!variantId) return;

    btn.classList.add('loading');
    btn.textContent = 'Adding…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      });

      if (res.ok) {
        btn.textContent = '✓ Added';
        setTimeout(() => {
          btn.textContent = 'Add to Bag';
          btn.classList.remove('loading');
        }, 1600);
        await refreshCart();
        openCart();
      } else {
        btn.textContent = 'Try Again';
        btn.classList.remove('loading');
      }
    } catch (err) {
      btn.textContent = 'Error';
      btn.classList.remove('loading');
    }
  });
});

// ── QUICK ADD (product cards) ──
// Delegated so it works for every card on collections, featured, and related
// grids — including any rendered after initial load.
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.product-quick-add');
  if (!btn) return;

  e.preventDefault();
  if (btn.classList.contains('loading')) return;

  const variantId = btn.dataset.variantId;

  // No purchasable variant resolved — send the shopper to the product page.
  if (!variantId) {
    const link = btn.closest('.product-card')?.querySelector('a[href]');
    if (link) window.location.href = link.href;
    return;
  }

  const originalText = (btn.textContent || 'Quick Add').trim();
  btn.classList.add('loading');
  btn.textContent = 'Adding…';

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    if (res.ok) {
      btn.textContent = '✓ Added';
      await refreshCart();
      openCart();
    } else {
      btn.textContent = 'Unavailable';
    }
  } catch (_) {
    btn.textContent = 'Try Again';
  }

  setTimeout(() => {
    btn.textContent = originalText;
    btn.classList.remove('loading');
  }, 1500);
});

// ── REFRESH CART COUNT ──
async function refreshCart() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const countEls = document.querySelectorAll('.cart-count');
    countEls.forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
  } catch (_) {}
}

// ── STICKY ATC ──
const stickyATC = document.getElementById('StickyATC');
const productForm = document.getElementById('ProductForm');

if (stickyATC && productForm) {
  const observer = new IntersectionObserver((entries) => {
    stickyATC.classList.toggle('visible', !entries[0].isIntersecting);
  }, { threshold: 0.5 });
  observer.observe(productForm);
}

// ── SUBSCRIPTION TOGGLE ──
document.querySelectorAll('.subscription-toggle').forEach(toggle => {
  toggle.addEventListener('click', () => {
    toggle.classList.toggle('active');
    const subPrice = toggle.dataset.subPrice;
    const oneTimePrice = toggle.dataset.oneTimePrice;
    const priceEl = document.querySelector('.product-price-main .current-price');
    if (priceEl) {
      priceEl.textContent = toggle.classList.contains('active') ? subPrice : oneTimePrice;
    }
  });
});

// ── NEWSLETTER FORM ──
document.querySelectorAll('.sub-form, .nl-form').forEach(form => {
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const emailInput = form.querySelector('input[type="email"]');
    const btn = form.querySelector('button[type="submit"]');
    if (!emailInput || !btn) return;

    const email = emailInput.value.trim();
    if (!email) return;

    btn.textContent = 'Joining…';
    btn.disabled = true;

    // Shopify customer newsletter signup
    try {
      const formData = new FormData();
      formData.append('contact[email]', email);
      formData.append('contact[tags]', 'newsletter');

      await fetch('/contact', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      });

      btn.textContent = '✓ Welcome to the community!';
      emailInput.value = '';
    } catch (_) {
      btn.textContent = '✓ You\'re in!';
    }
  });
});

// ── SMOOTH SCROLL ──
document.querySelectorAll('a[href^="#"]').forEach(link => {
  link.addEventListener('click', (e) => {
    const target = document.querySelector(link.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

// ── VARIANT SELECTION (multi-option aware) ──
(function () {
  const dataEl = document.querySelector('[data-product-variants]');
  if (!dataEl) return;

  let variants = [];
  try { variants = JSON.parse(dataEl.textContent); } catch (_) { return; }

  const groups = Array.from(document.querySelectorAll('.variant-swatches'));
  if (!groups.length) return;

  const allAtcBtns = () => document.querySelectorAll('.atc-btn');

  function formatMoney(cents) {
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function getSelectedOptions() {
    return groups.map(group => {
      const active = group.querySelector('.variant-swatch.active');
      return active ? active.dataset.value : null;
    });
  }

  function findVariant(selected) {
    return variants.find(v =>
      selected.every((val, i) => val === null || (v.options && v.options[i] === val))
    );
  }

  function updateSelection() {
    const variant = findVariant(getSelectedOptions());
    if (!variant) return;

    allAtcBtns().forEach(btn => {
      btn.dataset.variantId = variant.id;
      if (variant.available) {
        btn.disabled = false;
        if (!btn.classList.contains('loading')) btn.textContent = 'Add to Bag';
      } else {
        btn.disabled = true;
        btn.textContent = 'Sold Out';
      }
    });

    document.querySelectorAll('.product-price-main .current-price').forEach(el => {
      el.textContent = formatMoney(variant.price);
    });
  }

  groups.forEach(group => {
    group.querySelectorAll('.variant-swatch').forEach(swatch => {
      swatch.addEventListener('click', () => {
        group.querySelectorAll('.variant-swatch').forEach(s => s.classList.remove('active'));
        swatch.classList.add('active');
        updateSelection();
      });
    });
  });
})();

// ── CART QTY CHANGE ──
document.addEventListener('click', async (e) => {
  if (e.target.matches('[data-cart-qty-minus], [data-cart-qty-plus]')) {
    const lineItem = e.target.closest('[data-line-item]');
    if (!lineItem) return;

    const line = lineItem.dataset.lineItem;
    const qtyEl = lineItem.querySelector('.qty-num');
    let qty = parseInt(qtyEl?.textContent || '1');

    if (e.target.matches('[data-cart-qty-minus]')) qty = Math.max(0, qty - 1);
    else qty += 1;

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: qty })
      });

      if (res.ok) {
        if (qty === 0) {
          lineItem.remove();
        } else if (qtyEl) {
          qtyEl.textContent = qty;
        }
        await refreshCart();
      }
    } catch (_) {}
  }
});

// ── INIT ──
refreshCart();
